module.exports = __webpack_public_path__ + "static/media/SenaryoBG.9f5d2e0f.png";